module.exports = __webpack_public_path__ + "img/qrcode_for_gh_fcfc67db8562_860@2x.e4d297e7.png";